import FastAPIInstance from '../../services/risksystem3-public-api';
import { AdministratorModel } from './types';

export const getAllAdministrators = async (
  includeInactive: boolean = false,
): Promise<AdministratorModel[]> => {
  return (
    await FastAPIInstance.get<AdministratorModel[]>(
      `/v1/administrator?include_inactive=${includeInactive}`,
    )
  ).data;
};

export const getClientAdministrators = async (
  clientId: string,
): Promise<AdministratorModel[]> => {
  return (
    await FastAPIInstance.get<AdministratorModel[]>(
      `/v1/administrator/client/${clientId}`,
    )
  ).data;
};
